module.exports = __webpack_public_path__ + "assets/img/login_img.3c8aea2e.png";